import {
  message,
  Row,
  Spin,
} from "antd";
import {EyeOutlined} from "@ant-design/icons"
import React, { useEffect, useState } from "react";
import { API } from "../../constant";
import { useNavigate  } from "react-router-dom";
import { useAuthContext } from "../../context/AuthContext";
import { getToken } from "../../helpers";
import { Button, Space } from "antd";


const Clientes = () => {
  const [Clients, setClients] = useState([]);
  const [filter, setFilter] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { user, setUser } = useAuthContext();

  const handleClientesClick = () => {
    navigate(`/clients`);
  };

  function obtenerRangoDeVisitas() {
    const ahora = new Date(); // Fecha y hora actuales
    const hoy = new Date(ahora);
    const ayer = new Date(ahora);
  
    // Configurar las 3:00 AM del día actual
    const tresAM = new Date(hoy);
    tresAM.setHours(3, 0, 0, 0); // 3:00 AM de hoy
  
    // Configurar el día de "ayer" (1 día antes)
    ayer.setDate(hoy.getDate() - 1);
    ayer.setHours(0, 0, 0, 0); // Ayer a medianoche
  
    // Caso 1: Si la hora actual es antes de las 3:00 AM, mostrar las visitas desde ayer hasta las 3 AM de hoy
    if (ahora < tresAM) {
      return {
        desde: formatoFecha(ayer),  // Desde medianoche de ayer
        hasta: formatoFecha(tresAM) // Hasta las 3:00 AM de hoy
      };
    }
  
    // Caso 2: Si ya son después de las 3:00 AM, mostrar solo las visitas del día actual
    hoy.setHours(0, 0, 0, 0); // Hoy a medianoche
    return {
      desde: formatoFecha(hoy),  // Desde medianoche de hoy
      hasta: formatoFecha(ahora) // Hasta el momento actual
    };
  }
  
  // Función para formatear las fechas a ISO 8601
  const formatoFecha = (fecha) => `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(2, '0')}-${String(fecha.getDate()).padStart(2, '0')}T${String(fecha.getHours()).padStart(2, '0')}:${String(fecha.getMinutes()).padStart(2, '0')}:${String(fecha.getSeconds()).padStart(2, '0')}.000Z`;
  
  const fetchClients = async () => {
    const { desde, hasta } = obtenerRangoDeVisitas();
    setIsLoading(true);
  
    console.log("Haciendo petición a la API con la siguiente URL:");
    console.log(`${API}/visitas?populate=cliente&filters[agente][id]=${user?.id}&filters[createdAt][$gt]=${desde}&filters[createdAt][$lte]=${hasta}`);
  
  
    try {
      const response = await fetch(`${API}/visitas?populate=cliente&filters[agente][id]=${user?.id}&filters[createdAt][$gt]=${desde}&filters[createdAt][$lte]=${hasta}`, {
        headers: {
          'Authorization': `Bearer ${getToken()}`,
        },
      });
  
      console.log("Respuesta de la API:");
      console.log(response);
  
      const data = await response.json();
  
      console.log("Datos obtenidos de la API:");
      console.log(data.data);
  
      setClients(data.data ?? []);
    } catch (error) {
      console.error(error);
      message.error("Ha ocurrido un error");
    } finally {
      setIsLoading(false);
    }
  };
  

  

  useEffect(() => {
    // Asegúrate de que `user` esté definido antes de llamar a `fetchClients`
    if (user !== undefined && user !== null) {
      fetchClients();
    }
  }, [user]);

  
  const navigate = useNavigate();
  const handleNewVisitClick = (codigoCliente) => {
    navigate(`/lastVisit/${codigoCliente}`);
  };
  useEffect(() => {
    if (!getToken()) {
      navigate('/signin');
    }
  }, [navigate]);



  if (isLoading) {
    return <Spin size="large" />;
  }

  return (
    <Row gutter={[32, 32]}>
      <table className="table table-responsive-sm table-striped m-1">
        <thead>
          <tr>
            <th className="w-auto" scope="col">Cod</th>
            <th className="w-75" scope="col">Nombre</th>
            <th className="w-25" scope="col">Acciones</th>
          </tr>
        </thead>
        <tbody>
 
      {Clients.map((profile, index) => (

        <tr key={index}>
          <th scope="row">{profile.attributes.cliente.data.attributes.codigo}</th>
          <td className="fs-6">{profile.attributes.cliente.data.attributes.nombre}</td>
          <td>
          <button onClick={() =>handleNewVisitClick(profile.attributes.cliente.data.id)} className="btn btn-sm btn-outline-dark"><EyeOutlined /></button>
          </td>
        </tr>
      )
      )}
      </tbody>
      </table>
      <Button
    style={{ marginLeft: '15px' }}
    className="profile_save_btn"
    htmlType="button"
    type="primary"
    size="large"
    onClick={() => handleClientesClick()}
    ghost
  >
    Volver
  </Button>
    </Row>


  );
};

export default Clientes;